var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-map"},[_c('v-map',{ref:"map",attrs:{"zoom":7,"center":_vm.initialLocation}},[_c('v-icondefault'),_c('v-tilelayer',{attrs:{"url":"https://{s}.tile.osm.org/{z}/{x}/{y}.png"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }